import { type ReactElement } from 'react'
import SectionHeading from '../../../../shared/components/ui/headings/SectionHeading'
import ErrorBoundary from '../../../../shared/components/errorBoundary/ErrorBoundary'
import { ToggleInterval } from './RecentSalesSubSection/Components/ToggleInterval'
import { RecentSalesSubSection } from './RecentSalesSubSection/RecentSalesSubSection'
import { RecentActivitySubSection } from './RecentActivitySubSection/RecentActivitySubSection'

export function RecentSalesActivitySection (): ReactElement {
  return (
    <div>
      <div className="flex justify-start mb-4">
        <SectionHeading text="Recent Sales Activity" />
        <div className="w-8" />
        <ToggleInterval />
      </div>
      <div className="flex">
        <ErrorBoundary>
          <RecentSalesSubSection />
        </ErrorBoundary>

        <ErrorBoundary>
          <RecentActivitySubSection />
        </ErrorBoundary>
      </div>
    </div>
  )
}
